// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-menu-link.scss
 ** module id = 50
 ** module chunks = 0 1
 **/